import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export default function DocumentDrivingDetailIcon(field, useEmptyIcon = false, shouldBeAllValuesSelected = false) {
    const emptyDetailTitle = `At least one ${field} must be selected to enable document filing and automation.`;
    const title = 'This field enables document filing and helps us automate it for you!';
    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            color: 'rgba(40, 40, 46, 1)',
            maxWidth: 333,
            height: 36,
            fontSize: theme.typography.pxToRem(16),
            border: '1px solid rgba(177, 177, 177, 1)'
        },
    }));

    const FielImportIcon = () => {
        return (
            <HtmlTooltip title={title} placement="right" arrow>
                <FontAwesomeIcon icon={faFileImport} />
            </HtmlTooltip>
        );
    };

    const RedFileIcon = () => {
        return (
            <HtmlTooltip title={emptyDetailTitle} placement="right" arrow>
                <FontAwesomeIcon style={{color: '#CC3333'}} icon={faFileExcel} />
            </HtmlTooltip>
        );
    };

    return (
        (useEmptyIcon === true && !shouldBeAllValuesSelected) ? <RedFileIcon /> : <FielImportIcon />
    );
}